"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _utilityClassNames = require("@emcm-ui/utility-class-names");

var _utilityClassNames2 = _interopRequireDefault(_utilityClassNames);

var _Menu = require("./Menu");

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var rehydrator = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var getClassName, childrenNode, reactifiedChildren, rehydratedProps, href, fallbackHref;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getClassName = (0, _utilityClassNames2.default)("SiteHeaderMenu");
            childrenNode = domNode.querySelector("." + getClassName({ descendantName: "children" }));
            _context.next = 4;
            return rehydrateChildren(childrenNode);

          case 4:
            reactifiedChildren = _context.sent;
            rehydratedProps = {
              title: domNode.getAttribute("data-title")
            };
            href = domNode.getAttribute("data-href");
            fallbackHref = domNode.getAttribute("data-fallback-href");


            if (href && href.length) {
              rehydratedProps.href = href;
            }

            if (fallbackHref && fallbackHref.length) {
              rehydratedProps.fallbackHref = fallbackHref;
            }

            return _context.abrupt("return", _react2.default.createElement(
              _Menu2.default,
              rehydratedProps,
              reactifiedChildren
            ));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function rehydrator(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = rehydrator;